import Vue from 'vue';
import Router from 'vue-router';
import io from'socket.io-client';
import GanttBoard from './components/GanttBoard';
import MemberSchedule from './components/MemberSchedule';
import MSTalkRoom from './components/TalkRoom/MSTalkRoom';
import MSTalkMessageEditPhotoAlbum from './components/TalkRoom/MSTalkMessageEditPhotoAlbum';
import MSPhotoAlbum from './components/PhotoAlbum/MSPhotoAlbum';
import MSPhotoAlbumSlideShow from './components/PhotoAlbum/MSPhotoAlbumSlideShow';
import Login from './components/Login';
import SignUp from './components/SignUp';
import GBPhotoAlbumList from './components/PhotoAlbum/GBPhotoAlbumList';
import GBPhotoAlbumEdit from './components/PhotoAlbum/GBPhotoAlbumEdit';
import GBPhotoAlbumCreate from './components/PhotoAlbum/GBPhotoAlbumCreate';
import GBPhotoAlbumSlideShow  from'./components/PhotoAlbum/GBPhotoAlbumSlideShow';
import PhotoMng from './components/PhotoAlbum/GBPhotoAlbumMng';
import NotFound404 from './components/NotFound404';
import Notification from './classes/Notification';
import store from './store'
import DataSetManager from './classes/DataSetManager';
import TokenManager from './classes/TokenManager';
import { PERMISSION, GANTTBOARD_EVENT_ID } from './data/Const';

Vue.use(Router);

const initWebsock = (contractor_id) => {
	if (store.getters.isConnectedSocketIO)
		return;

	var socketio = io('/' + contractor_id);
	socketio.on('connectet',(data) => {
		store.commit('socketio_id', data.id);
	});
	socketio.on('disconnect',() => {
		store.commit('socketio', null);
		store.commit('socketio_id', null);
	});
	socketio.on('photoalbum-archive', async (data) => {
		let access_token, form;
		switch (data.code) {
		case 201:
			access_token = await DataSetManager.confirmAccessToken(store);
			if (access_token === null) {
				store.commit('addNotification', Notification.error('もう一度ログインしてください'));
				logout(contractor_id);
			}
			store.dispatch('emitGanttBoardEvent', {
				type: GANTTBOARD_EVENT_ID.ALBUM_DOWNLOAD,
				data: data,
			});
			form = document.createElement('form');
			form.action = data.url;
			form.method = 'GET';
			form.target = '_self';
			var input = document.createElement('input');
			input.value = access_token.token;
			input.name = 'access_token';
			form.appendChild(input);
			document.body.appendChild(form);
			form.submit();
			document.body.removeChild(form);
			break;
		default:
			store.dispatch('addNotification', Notification.error('ダウンロードに失敗しました').notimeout());
		}
	});
	socketio.on("photoalbum-update", (data) => {
		store.dispatch('emitGanttBoardEvent', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			data: data,
		});
	});
	socketio.on("talkroom-append-message", (data) => {
		store.dispatch('emitGanttBoardEvent', {
			type: GANTTBOARD_EVENT_ID.TALKROOM_APPEND_MESSAGE,
			data: data,
		});
	});
	socketio.on("printout", async (data) => {
		let access_token, form;
		switch(data.code) {
		case 201: 
			access_token = await DataSetManager.confirmAccessToken(store);
			if (access_token === null) {
				store.commit('addNotification', Notification.error('もう一度ログインしてください'));
				logout(contractor_id);
			}
			store.commit('endPrintSchedule', null);
			form = document.createElement('form');
			form.action = data.url;
			form.method = 'GET';
			var input = document.createElement('input');
			input.value = access_token.token;
			input.name = 'access_token';
			form.appendChild(input);
			document.body.appendChild(form);
			form.submit();
			document.body.removeChild(form);
			break;
		default:
			store.dispatch('addNotification', Notification.error('印刷に失敗しました').notimeout());
			store.commit('endPrintSchedule', null);
		}
	});
	socketio.on("notification", (data) => {
		if (store.getters.isExclusive)
			return;
		let notification = null;
		switch(data.code) {
		case 406:
			notification = Notification.info('データを同期しました', 'notificationUpdate');
			store.dispatch('addNotification',notification);
			updateDataSet(contractor_id, opt_update)
				.then(() => {
					store.dispatch('emitGanttBoardEvent', {
						type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
						data: data,
					});
				});
			break;
		default :
			notification = Notification.error('通信に失敗しました').notimeout();	
			store.dispatch('addNotification',notification);
		}
	});
	store.commit('socketio', socketio);
};

const updateDataSet = async (contractor_id, opt) => {
	if (opt === undefined)
		opt = {};
	opt.force_update = true;

	let dataset_manager = store.getters.datasetManager;
	await dataset_manager.updateDataSet(opt)
		.catch((e) => {
			if (e.token) {
				store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
				throw e;
			} else if (e.response) {
				let notification = null;

				switch(e.response.status) {
				case 400:
					notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
					break;
				case 401:
					notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
					throw e;
				case 404:
					notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
					break;
				case 500:
					notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
					break;
				case 504:
					notification = Notification.error('タイムアウトしました', 'notificationCreateData');
					break;
				default :
					notification = Notification.error('通信に失敗しました', 'notificationCreateData');
					break;
				}

				if (notification)
					store.commit('addNotification', notification);
			} else {
				throw e;
			}
		});
};

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'NotFound404',
			component: NotFound404,
		},
		{
			path: '/:contractor_id/member/:id',
			name: 'MemberSchedule',
			component: MemberSchedule,
		},
		{
			path: '/:contractor_id/member/:id/talkroom/:talkroom_id/photoalbum',
			name: 'MSTalkMessageEditPhotoAlbum',
			component: MSTalkMessageEditPhotoAlbum,
		},
		{
			path: '/:contractor_id/member/:id/photoalbum/:photoalbum_id/',
			name: 'MSPhotoAlbum',
			component: MSPhotoAlbum,
		},
		{
			path: '/:contractor_id/member/:id/photoalbum/:photoalbum_id/slideshow',
			name: 'MSPhotoAlbumSlideShow',
			component: MSPhotoAlbumSlideShow,
		},
		{
			path: '/:contractor_id/',
			name: 'GanttBoard',
			component: GanttBoard,
		},
		{
			path: '/:contractor_id/login/',
			name: 'Login',
			component: Login,
		},
		{
			path: '/:contractor_id/signup/',
			name: 'SignUp',
			component: SignUp,
		},
		{
			path: '/:contractor_id/member/:id/talkroom/:talkroom_id',
			name: 'MSTalkRoom',
			component: MSTalkRoom,
		},
		{
			path: '/:contractor_id/photoalbum/project/:project_id/album/',
			name: 'GBPhotoAlbumEditProject',
			component: GBPhotoAlbumEdit,
		},
		{
			path: '/:contractor_id/photoalbum/project/:project_id/schedule/:schedule_id/album/',
			name: 'GBPhotoAlbumEditSchedule',
			component: GBPhotoAlbumEdit,
		},
		{
			path: '/:contractor_id/photoalbum/member/:member_id/schedule/:schedule_id/album/',
			name: 'GBPhotoAlbumEditMember',
			component: GBPhotoAlbumEdit,
		},
		{
			path: '/:contractor_id/photoalbum/project/:project_id/album/:photoalbum_id/slideshow',
			name: 'GBPhotoAlbumSlideShowProject',
			component: GBPhotoAlbumSlideShow,
		},
		{
			path: '/:contractor_id/photoalbum/project/:project_id/schedule/:schedule_id/album/:photoalbum_id/slideshow',
			name: 'GBPhotoAlbumSlideShowSchedule',
			component: GBPhotoAlbumSlideShow,
		},
		{
			path: '/:contractor_id/photoalbum/member/:member_id/schedule/:schedule_id/album/:photoalbum_id/slideshow',
			name: 'GBPhotoAlbumSlideShowMember',
			component: GBPhotoAlbumSlideShow,
		},
		{
			path: '/:contractor_id/photoalbum/project/:project_id/create',
			name: 'GBPhotoAlbumCreateProject',
			component: GBPhotoAlbumCreate,
		},
		{
			path: '/:contractor_id/photoalbum/project/:project_id/schedule/:schedule_id/create',
			name: 'GBPhotoAlbumCreateSchedule',
			component: GBPhotoAlbumCreate,
		},
		{
			path: '/:contractor_id/photoalbum/member/:member_id/schedule/:schedule_id/create',
			name: 'GBPhotoAlbumCreateMember',
			component: GBPhotoAlbumCreate,
		},
		{
			path: '/:contractor_id/photoalbum/project/:project_id/',
			name: 'GBPhotoAlbumListProject',
			component: GBPhotoAlbumList,
		},
		{
			path: '/:contractor_id/photoalbum/member/:member_id/',
			name: 'GBPhotoAlbumListMember',
			component: GBPhotoAlbumList,
		},
		{
			path: '/:contractor_id/photoalbum/project/',
			name: 'ProjectPhotoList',
			component: PhotoMng,
		},
		{
			path: '/:contractor_id/photoalbum/member/',
			name: 'MemberPhotoList',
			component: PhotoMng,
		},
	],
});

const logout = (contractor_id) => {
	store.dispatch('logout');
	router.push({ name: 'Login', params: { 'contractor_id': contractor_id }})
};

const validateRefreshToken = async (refresh_token) => {
	if(!TokenManager.isExpireSoonRefreshToken(refresh_token))
		return refresh_token;
		
	//リフレッシュトークン延長
	return await TokenManager.refreshTokenRequest(refresh_token.token);
};

const refreshToken = async (contractor_id) => {
	let access_token = store.state.ganttboard.access_token;
	let refresh_token = store.state.ganttboard.refresh_token;

	if (!refresh_token || refresh_token.iss !== contractor_id) {
		return null;
	}

	if (!TokenManager.isExpiredAccessToken(access_token))
		return access_token;

	if (TokenManager.isExpiredRefreshToken(refresh_token)) {
		//リフレッシュトークン期限切れ
		return null;
	}

	refresh_token = await validateRefreshToken(refresh_token)
		.catch(() => {
			return null;
		});
	if (!refresh_token){
		return null;
	}
	
	store.commit('setRefreshToken', refresh_token);
	//アクセストークン再発行
	access_token = await TokenManager.accessTokenRequest(refresh_token.token)
		.catch(() => {
			return null;
		});
	
	if (!access_token){
		return null;
	}
	
	if (!(access_token.pms)) {
		store.dispatch('addNotification', Notification.error('権限がありません') );
		return null;
	}
	
	store.commit('setAccessToken', access_token);

	return access_token;
};

const isLogin = (to) => {
	return (to.name === "Login") || (to.name === "SignUp");
};
const isRequiredAccessToken = (to) => {
	return to.name !== "NotFound404" && !isLogin(to);
};
const isWorker = (to) => {
	const regex = new RegExp('^/[^/]+/member/');
	return to.path.search(regex) === 0;
};
const isGanttBoard = (to) => {
	return !isWorker(to);
};
const isDefaultPeriod = (from) => {
	return (!from.name) || isLogin(from) || isWorker(from);
};

const opt_update = { for_member: false };
router.beforeEach(async (to, from, next) => {
	if (to.name !== from.name)
		store.commit('startLoading');

	let contractor_id = to.params.contractor_id;
	if (to.name !== 'NotFound404' && contractor_id === undefined) {
		router.push({ name: 'NotFound404' });
		return;
	}

	let access_token = store.state.ganttboard.access_token;
	let refresh_token = store.state.ganttboard.refresh_token;

	if (to.name !== 'NotFound404') {
		if (refresh_token && refresh_token.iss != contractor_id) {
			logout(contractor_id);
			return;
		}
	}
	if (isLogin(to)) {
		access_token = await refreshToken(contractor_id);
		if (access_token) {
			let name = (access_token.pms == PERMISSION.ROLE.WORKER)
				? 'MemberSchedule'
				: 'GanttBoard';
			router.push({ 'name': name, params: { 'contractor_id': contractor_id } });
			return;
		}
		next();
		return;
	} else if (isRequiredAccessToken(to)) {
		opt_update.for_member = false;
		let default_period = isDefaultPeriod(from);

		access_token = await refreshToken(contractor_id);
		if (!access_token) {
			logout(contractor_id);
			return;
		}

		if (isGanttBoard(to)) {
			updateDataSet(contractor_id, {default_period: default_period}).then(() => {
				initWebsock(contractor_id);
				next();
			}).catch(() => {
				logout(contractor_id);
			});
			return;
		} else if (isWorker(to)) {
			opt_update.for_member = true;
			updateDataSet(contractor_id, Object.assign({default_period: true}, opt_update)).then(() => {
				initWebsock(contractor_id);
				next();
			}).catch(() => {
				logout(contractor_id);
			});
			return;
		}
	}

	next();
});
router.afterEach(() => {
	store.commit('endLoading');
});

export default router;
